import PaymentAPIService from "../payment_api_service";
import apiUtils from "../../../../core/utils/api_utils";
import { encryptionService } from "../../../presentation/di/di";

export default class PaymentAPIServiceImpl extends PaymentAPIService {
  static #instance = null;

  constructor() {
    if (PaymentAPIServiceImpl.#instance) {
      return PaymentAPIServiceImpl.#instance;
    }
    super();
    PaymentAPIServiceImpl.#instance = this;
  }

  async processSubscriptionPayment(data) {
    console.log("payment payload", data);
    try {
      const response = await apiUtils.post(`/api/payment/process`, data);
      return response.data;
    } catch (err) {
      console.log(err);
      return err.response
        ? err.response.data
        : { success: false, message: "Something went wrong", data: [], error: [{ type: "UNKNOWN_ERROR", message: "Something went wrong" }] };
    }
  }
}
